
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { groupBy, mapBy } from "./utils.js";

export async function count(id) {
    return get(`guests/?id=${id}&count=true`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return mapBy(d, "age");
        })
        .catch(e => {
            return [];
        });
}

export async function attending(id) {
    return get(`guests/?id=${id}&attending=true`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return mapBy(d, "age");
        })
        .catch(e => {
            return [];
        });
}

export async function refresh_count(id) {
    let gc = {
        total: {
            attending: 0,
            count: 0,
        },
        adult: {
            attending: 0,
            count: 0,
        },
        teen: {
            attending: 0,
            count: 0,
        },
        child: {
            attending: 0,
            count: 0,
        },
        baby: {
            attending: 0,
            count: 0,
        },
    };

    try {
        let r = await count(id);
        gc.total.count = r[null] ? r[null][0]["count"] : 0;
        gc.adult.count = r["A"] ? r["A"][0]["count"] : 0;
        gc.teen.count = r["T"] ? r["T"][0]["count"] : 0;
        gc.child.count = r["C"] ? r["C"][0]["count"] : 0;
        gc.baby.count = r["B"] ? r["B"][0]["count"] : 0;

        r = await attending(id);
        gc.total.attending = r[null] ? r[null][0]["count"] : 0;
        gc.adult.attending = r["A"] ? r["A"][0]["count"] : 0;
        gc.teen.attending = r["T"] ? r["T"][0]["count"] : 0;
        gc.child.attending = r["C"] ? r["C"][0]["count"] : 0;
        gc.baby.attending = r["B"] ? r["B"][0]["count"] : 0;

    } catch (e) {
        console.log(e);
    }

    return gc;
}

export async function load(id, groupby) {

    if (groupby === undefined) {
        groupby = true;
    }

    return get(`guests/?id=${id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return groupby ? groupBy(d, "invitation_id") : d;
        })
        .catch(e => {
            return [];
        });
}

export async function loadGroup(id, invitation_id) {
    return get(`guests/?id=${id}&invitation_id=${invitation_id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

export async function loadGroupFromInvitationCode(id, invitation_code) {
    return get(`guests/?id=${id}&invitation_code=${invitation_code}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

/**
 * Create Invitation.
 */
export function create(id, firstname, lastname, email, age, gender, age_val) {
    return post('guests/',
        {
            id: id,
            email: email,
            firstname: firstname,
            lastname: lastname,
            age: age,
            gender: gender,
            age_val: age_val
        }, token || DEV_TOKEN);
}

export function updateGroup(id, invitation_id, name) {
    return put('guests/',
        {
            id: id,
            invitation_id: invitation_id,
            name: name
        }, token || DEV_TOKEN);
}

/**
 * Add Guest
 */
export function add(id, invitation_id, guest_id, firstname, lastname, email, age, gender, attending, food_restriction, favorite_songs, age_val) {
    return put('guests/',
        {
            id: id,
            invitation_id: invitation_id,
            addGuest: true,
            guest_id: guest_id,
            email: email,
            firstname: firstname,
            lastname: lastname,
            age: age,
            gender: gender,
            attending: attending,
            food_restriction: food_restriction,
            favorite_songs: favorite_songs,
            age_val: age_val
        }, token || DEV_TOKEN);
}

/**
 * Delete Guest
 */
export function deleteGuest(id, invitation_id, guest_id) {
    return del('guests/',
        {
            id: id,
            invitation_id: invitation_id,
            guest_id: guest_id
        }, token || DEV_TOKEN);
}

